import React, { useEffect, useState } from "react";

import { Formik, Form } from "formik";
import * as Yup from "yup";

import { useSelector } from "react-redux";

import { TextField, Typography } from "@mui/material";
import {
  consultaEstFinanciero,
  crearClienteEstadoFinanciero,
  obtenerPesosActividadEconomica,
} from "../services/clienteService";

import { NumberFormatCustom } from "app/modules/shared/mask/mascaraInputDinero";

import SpinnerLoadSrx from "app/modules/shared/components/SpinnerLoadSrx";
import AcceptServiceresponse from "app/modules/shared/components/AcceptServiceresponse";
import { SCSLoadingButton } from "app/modules/common/components/Buttons/SCSButtons";
import SCSAccordion from "app/modules/common/components/Accordions/SCSAccordion";

import { StyleInputs } from "../styles/themes";

import SelectItemsCatalogs, {
  SelectItemsCatalogsSpecial,
} from "app/modules/common/components/Selector";

import "../styles/main.css";
import { Box } from "@mui/system";
import MoreInfoPopover from "app/modules/shared/components/MoreInfoPopover";

const FormClienteEstadoFinanciero = ({
  idCliente,
  setActividadEconomica,
  setInfoClienteGrabada,
}) => {
  const { authUser } = useSelector(({ auth }) => auth);
  const [clienteInfo, setClienteInfo] = useState(null);
  const [controlActividad, setControlActividad] = useState(true);
  const [datosEnviadosCorrectamente, setDatosEnviadosCorrectamente] =
    useState(false);

  const [idEstadoFinancieroAux, setIdEstadoFinancieroAux] = useState(0);

  const [pesosDependiente, setPesosDependiente] = useState({
    COMISION: 100,
    OTROS: 100,
    REMESA: 100,
    RENTA: 100,
    SUELDO: 100,
    VENTA: 100,
  });

  const [pesosIndependiente, setPesosIndependiente] = useState({
    COMISION: 100,
    OTROS: 100,
    REMESA: 100,
    RENTA: 100,
    SUELDO: 100,
    VENTA: 100,
  });

  useEffect(() => {
    const getData = async () => {
      let infoEstadoFinanciero;

      try {
        const informacionEstadoFinanciero = await consultaEstFinanciero(
          idCliente
        );

        if (informacionEstadoFinanciero.state) {
          infoEstadoFinanciero = informacionEstadoFinanciero.data;

          setIdEstadoFinancieroAux(
            informacionEstadoFinanciero.data.idEstadoFinanciero
          );
        } else {
          infoEstadoFinanciero = {};
        }
      } catch (error) {
        console.log(error);
      }

      const res = {
        ...infoEstadoFinanciero,
      };

      setClienteInfo(res);
    };
    getData();
  }, []);

  useEffect(() => {
    const getPesosDependiente = async () => {
      try {
        const respuestaPesosDependiente = await obtenerPesosActividadEconomica(
          "AECDEP"
        );

        if (respuestaPesosDependiente.state) {
          const objectPesosDependiente = respuestaPesosDependiente.data.reduce(
            (acumuladorPesos, valorPeso) => {
              const objetoDependiente = {
                ...acumuladorPesos,
                [valorPeso.tipoIngreso]: valorPeso.porcentaje,
              };

              return objetoDependiente;
            },
            {}
          );

          setPesosDependiente(objectPesosDependiente);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getPesosDependiente();
  }, []);

  useEffect(() => {
    const getPesosIndependiente = async () => {
      try {
        const respuestaPesosDependiente = await obtenerPesosActividadEconomica(
          "AECIND"
        );

        if (respuestaPesosDependiente.state) {
          const objectPesosIndependiente =
            respuestaPesosDependiente.data.reduce(
              (acumuladorPesos, valorPeso) => {
                const objetoIndependiente = {
                  ...acumuladorPesos,
                  [valorPeso.tipoIngreso]: valorPeso.porcentaje,
                };

                return objetoIndependiente;
              },
              {}
            );

          setPesosIndependiente(objectPesosIndependiente);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getPesosIndependiente();
  }, []);

  const condicionRederActividadIndependiente = (origenIngresos) => {
    if (origenIngresos === "AECDEP") {
      setControlActividad(false);
      setActividadEconomica(false);
      return false;
    }
    setControlActividad(true);
    setActividadEconomica(true);
    return true;
  };

  /*  Agregar llamada para obtener los porcentajes y verificar los valores ingresados  */
  const calcularTotalIngresos = (valores) => {
    let respuestaPorcentajes;
    if (valores.origenIngresos === "AECDEP") {
      respuestaPorcentajes = {
        ...pesosDependiente,
      };
    } else {
      respuestaPorcentajes = {
        ...pesosIndependiente,
      };
    }

    let { ingresoMensual, comision, renta, remesa, ventas, otrosIngresos } =
      valores;

    if (valores.origenIngresos === "AECDEP") {
      ventas = 0;
    } else {
      ingresoMensual = 0;
      comision = 0;
    }

    const totalIngresos =
      Number(ingresoMensual) * (Number(respuestaPorcentajes.SUELDO) / 100) +
      Number(comision) * (Number(respuestaPorcentajes.COMISION) / 100) +
      Number(renta) * (Number(respuestaPorcentajes.RENTA) / 100) +
      Number(remesa) * (Number(respuestaPorcentajes.REMESA) / 100) +
      Number(ventas) * (Number(respuestaPorcentajes.VENTA) / 100) +
      Number(otrosIngresos) * (Number(respuestaPorcentajes.OTROS) / 100);

    return totalIngresos.toFixed(2);
  };

  /* dependiendo del origen de ingresos dependiente/independiente cambian los campos de ingresos */
  const validarOrigenIngresos = (origenIngresos) => {
    if (origenIngresos === "AECDEP") {
      return true;
    } else {
      return false;
    }
  };

  const configuracionDatosEnvio = async (valoresAux, setSubmitting) => {
    setSubmitting(true);

    const valores = { ...valoresAux };

    if (valoresAux.origenIngresos === "AECIND") {
      valores.ingresoMensual = 0;
      valores.comision = 0;
    } else if (valoresAux.origenIngresos === "AECDEP") {
      valores.ventas = 0;
    }

    const today = new Date().toLocaleString("en-US");

    const informacionEstadoFinanciero = {
      idCliente: idCliente,
      idEstadoFinanciero: idEstadoFinancieroAux,
      actividadEconomica: valores.actividadEconomica,
      origenIngresos: valores.origenIngresos,

      ingresoMensual: Number(valores.ingresoMensual),
      comision: Number(valores.comision),
      renta: Number(valores.renta),
      remesa: Number(valores.remesa),
      ventas: Number(valores.ventas),
      otrosIngresos: Number(valores.otrosIngresos),
      totalIngresos: Number(valores.totalIngresos),
      detalleOtrosIngresos: valores.detalleOtrosIngresos.toUpperCase(),

      profesion: valores.profesion,
      esActivo: true,

      fechaCreacion: today,
      usuarioCreacion: authUser.key,
      estacionCreacion: authUser.estacion,
    };

    try {
      const respuestaClienteInformacion = await crearClienteEstadoFinanciero(
        informacionEstadoFinanciero
      );

      if (respuestaClienteInformacion.state) {
        setDatosEnviadosCorrectamente(true);

        setIdEstadoFinancieroAux(respuestaClienteInformacion.data);
        if (setInfoClienteGrabada) {
          setInfoClienteGrabada((args) => ({
            ...args,
            financiero: true,
          }));
        }

        setTimeout(() => {
          setSubmitting(false);
          setDatosEnviadosCorrectamente(false);
        }, 1000);
      } else {
        setSubmitting(false);
        alert(`${respuestaClienteInformacion.message}`);
      }
    } catch (error) {
      setSubmitting(false);
      alert(`${error.response.data.message}`);
      console.log(error);
    } finally {
      setSubmitting(false);
    }
  };

  const InfoFinanciera = ({}) => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: 1,
          p: 1,
          width: "100%",
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          INFORMACIÓN FINANCIERA
        </Typography>

        <Typography variant="body2" color="text.secondary">
          Se refiere a la informacion sobre tus ingresos y egresos, toma en
          cuenta que estos son acorde a tu actividad económica.
        </Typography>
      </Box>
    );
  };

  return (
    <>
      {clienteInfo ? (
        <>
          <Formik
            initialValues={{
              origenIngresos: clienteInfo.origenIngresos || "",
              actividadEconomica: clienteInfo.actividadEconomica || "",
              profesion: clienteInfo.profesion || "",
              ingresoMensual: clienteInfo.ingresoMensual || 0,
              comision: clienteInfo.comision || 0,
              renta: clienteInfo.renta || 0,
              remesa: clienteInfo.remesa || 0,
              ventas: clienteInfo.ventas || 0,
              otrosIngresos: clienteInfo.otrosIngresos || 0,
              totalIngresos: clienteInfo.totalIngresos || 0,
              detalleOtrosIngresos: clienteInfo.detalleOtrosIngresos || "",
            }}
            validationSchema={Yup.object({
              origenIngresos: Yup.string().required(
                "Origen Ingresos requerido"
              ),
              actividadEconomica: Yup.string().required(
                "Actividad Economica requerido"
              ),
            })}
            onSubmit={(values, { setSubmitting }) => {
              configuracionDatosEnvio(values, setSubmitting);
            }}
          >
            {({
              values,
              handleChange,
              touched,
              errors,
              handleBlur,
              isSubmitting,
            }) => (
              <Form>
                <SCSAccordion
                  tituloCabecera="Estado Financiero"
                  tieneInfo={true}
                  componenteInformacion={<InfoFinanciera />}
                >
                  <div className="cliente-informacion-seccion">
                    <SelectItemsCatalogs
                      pais="ECU"
                      especial="false"
                      catalogos="FTEING"
                      grupo={1}
                      name="origenIngresos"
                      labelName="Origen Ingresos"
                      componentSize={{ pcWidth: 25, phoneWidth: 45 }}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                    />
                    {condicionRederActividadIndependiente(
                      values.origenIngresos
                    )}
                    <SelectItemsCatalogsSpecial
                      pais="ECU"
                      especial="false"
                      catalogos="TIPOACTEC"
                      codPadre={values.origenIngresos}
                      grupo={1}
                      name="actividadEconomica"
                      labelName="Actividad Economica"
                      componentSize={{ pcWidth: 25, phoneWidth: 47 }}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                    />

                    {/* cambio de catalogo de PROF -> CARGO   */}
                    <SelectItemsCatalogs
                      pais="ECU"
                      especial="false"
                      catalogos="CARGO"
                      grupo={1}
                      name="profesion"
                      labelName="Profesión"
                      componentSize={{ pcWidth: 35, phoneWidth: 96 }}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                    />
                  </div>

                  <div>
                    <h3>Ingresos</h3>
                  </div>

                  {validarOrigenIngresos(values.origenIngresos) ? (
                    <>
                      <div className="cliente-informacion-seccion">
                        <TextField
                          id="ingresoMensual"
                          name="ingresoMensual"
                          label="Ingreso Mensual"
                          sx={StyleInputs(16, 45)}
                          value={values.ingresoMensual}
                          onChange={handleChange}
                          size="small"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                          error={
                            touched.ingresoMensual &&
                            Boolean(errors.ingresoMensual)
                          }
                          helperText={
                            touched.ingresoMensual && errors.ingresoMensual
                          }
                          onBlur={handleBlur}
                        />

                        <TextField
                          id="comision"
                          name="comision"
                          label="Comisión"
                          sx={StyleInputs(16, 47)}
                          value={values.comision}
                          onChange={handleChange}
                          size="small"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                          error={touched.comision && Boolean(errors.comision)}
                          helperText={touched.comision && errors.comision}
                          onBlur={handleBlur}
                        />

                        <TextField
                          id="renta"
                          name="renta"
                          label="Renta"
                          sx={StyleInputs(16, 45)}
                          value={values.renta}
                          onChange={handleChange}
                          size="small"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                          error={touched.renta && Boolean(errors.renta)}
                          helperText={touched.renta && errors.renta}
                          onBlur={handleBlur}
                        />

                        <TextField
                          id="remesa"
                          name="remesa"
                          label="Remesa"
                          sx={StyleInputs(16, 47)}
                          value={values.remesa}
                          onChange={handleChange}
                          size="small"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                          error={touched.remesa && Boolean(errors.remesa)}
                          helperText={touched.remesa && errors.remesa}
                          onBlur={handleBlur}
                        />
                        <TextField
                          id="otrosIngresos"
                          name="otrosIngresos"
                          label="Otros Ingresos"
                          sx={StyleInputs(16, 45)}
                          value={values.otrosIngresos}
                          onChange={handleChange}
                          size="small"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                          error={
                            touched.otrosIngresos &&
                            Boolean(errors.otrosIngresos)
                          }
                          helperText={
                            touched.otrosIngresos && errors.otrosIngresos
                          }
                          onBlur={handleBlur}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="cliente-informacion-seccion">
                        <TextField
                          id="ventas"
                          name="ventas"
                          label="Ventas"
                          sx={StyleInputs(20, 45)}
                          value={values.ventas}
                          onChange={handleChange}
                          size="small"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                          error={touched.ventas && Boolean(errors.ventas)}
                          helperText={touched.ventas && errors.ventas}
                          onBlur={handleBlur}
                        />

                        <TextField
                          id="renta"
                          name="renta"
                          label="Renta"
                          sx={StyleInputs(20, 47)}
                          value={values.renta}
                          onChange={handleChange}
                          size="small"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                          error={touched.renta && Boolean(errors.renta)}
                          helperText={touched.renta && errors.renta}
                          onBlur={handleBlur}
                        />

                        <TextField
                          id="remesa"
                          name="remesa"
                          label="Remesa"
                          sx={StyleInputs(20, 45)}
                          value={values.remesa}
                          onChange={handleChange}
                          size="small"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                          error={touched.remesa && Boolean(errors.remesa)}
                          helperText={touched.remesa && errors.remesa}
                          onBlur={handleBlur}
                        />

                        <TextField
                          id="otrosIngresos"
                          name="otrosIngresos"
                          label="Otros Ingresos"
                          sx={StyleInputs(20, 47)}
                          value={values.otrosIngresos}
                          onChange={handleChange}
                          size="small"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                          error={
                            touched.otrosIngresos &&
                            Boolean(errors.otrosIngresos)
                          }
                          helperText={
                            touched.otrosIngresos && errors.otrosIngresos
                          }
                          onBlur={handleBlur}
                        />
                      </div>
                    </>
                  )}

                  <div className="cliente-informacion-seccion">
                    <TextField
                      disabled
                      id="totalIngresos"
                      name="totalIngresos"
                      label="Total Ingresos"
                      sx={StyleInputs(20, 33)}
                      value={calcularTotalIngresos(values)}
                      onChange={handleChange}
                      size="small"
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                      error={
                        touched.totalIngresos && Boolean(errors.totalIngresos)
                      }
                      helperText={touched.totalIngresos && errors.totalIngresos}
                      onBlur={handleBlur}
                    />

                    <TextField
                      id="detalleOtrosIngresos"
                      name="detalleOtrosIngresos"
                      type="text"
                      label="Detalle Otros Ingresos"
                      sx={StyleInputs(70, 60)}
                      value={values.detalleOtrosIngresos}
                      onChange={handleChange}
                      size="small"
                      inputProps={{
                        style: {
                          textTransform: "uppercase",
                        },
                      }}
                      error={
                        touched.detalleOtrosIngresos &&
                        Boolean(errors.detalleOtrosIngresos)
                      }
                      helperText={
                        touched.detalleOtrosIngresos &&
                        errors.detalleOtrosIngresos
                      }
                      onBlur={handleBlur}
                    />
                  </div>

                  <div className="confirmar-estados-servicios">
                    <SCSLoadingButton loading={isSubmitting} titulo="GUARDAR" />

                    {datosEnviadosCorrectamente && <AcceptServiceresponse />}
                  </div>
                </SCSAccordion>
              </Form>
            )}
          </Formik>
        </>
      ) : (
        <SpinnerLoadSrx />
      )}
    </>
  );
};

export default FormClienteEstadoFinanciero;
